import { useState, useCallback } from 'react'
import { GovernedClientsService } from '../services/governedClients'
import type { ClientPortfolioResponse } from '../types'

interface UseClientPortfolioReturn {
  portfolioData: ClientPortfolioResponse | null
  loading: boolean
  error: Error | null
  fetchClientPortfolio: (clientIdentifier: string) => Promise<void>
  clearData: () => void
}

export const useClientPortfolio = (): UseClientPortfolioReturn => {
  const [portfolioData, setPortfolioData] = useState<ClientPortfolioResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchClientPortfolio = useCallback(async (clientIdentifier: string) => {
    try {
      setLoading(true)
      setError(null)
      const data = await GovernedClientsService.getClientPortfolio(clientIdentifier)
      setPortfolioData(data)
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch client portfolio'))
      setPortfolioData(null)
    } finally {
      setLoading(false)
    }
  }, [])

  const clearData = useCallback(() => {
    setPortfolioData(null)
    setError(null)
  }, [])

  return {
    portfolioData,
    loading,
    error,
    fetchClientPortfolio,
    clearData
  }
}